const ThumbsDown = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.3335 1.3335V8.66683M14.6669 6.5335V3.46683C14.6669 2.72009 14.6669 2.34672 14.5215 2.06151C14.3937 1.81063 14.1897 1.60665 13.9389 1.47882C13.6536 1.3335 13.2803 1.3335 12.5335 1.3335H5.41221C4.43788 1.3335 3.95072 1.3335 3.55725 1.51179C3.21046 1.66892 2.91573 1.92178 2.70769 2.24064C2.47164 2.60243 2.39757 3.08392 2.24942 4.04691L1.9007 6.31358C1.70529 7.5837 1.60759 8.21877 1.79607 8.71291C1.96149 9.14662 2.27263 9.50929 2.67615 9.73874C3.13589 10.0002 3.77842 10.0002 5.06349 10.0002H5.6002C5.97357 10.0002 6.16025 10.0002 6.30286 10.0728C6.4283 10.1367 6.53029 10.2387 6.5942 10.3642C6.66686 10.5068 6.66686 10.6935 6.66686 11.0668V13.0229C6.66686 13.9308 7.40286 14.6668 8.31076 14.6668C8.52731 14.6668 8.72354 14.5393 8.81149 14.3414L11.052 9.30028C11.1539 9.071 11.2049 8.95635 11.2854 8.87229C11.3566 8.79798 11.444 8.74116 11.5408 8.70629C11.6504 8.66683 11.7758 8.66683 12.0267 8.66683H12.5335C13.2803 8.66683 13.6536 8.66683 13.9389 8.5215C14.1897 8.39367 14.3937 8.1897 14.5215 7.93882C14.6669 7.6536 14.6669 7.28023 14.6669 6.5335Z"
      stroke="#535862"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default ThumbsDown;
